import React from 'react'
import Photo from "../../../../Assests/Products/Hospitalmang/Account.png"
const AccountManag = () => {
    return (
        <div className="CompareAnalysis-2" data-aos="zoom-in-left" style={{ width: "90%", margin: "auto" }}>
            <div className="CompareAnalysis-Def">
                <h2>

                    Accounts Managemnet        </h2>
                <p>
                    Manage hospital finances efficiently, with tools to handle billing, invoicing, and financial reporting, ensuring accuracy and compliance.
                </p>

            </div>
            <div className="CompareAnalysis-Photo">
                <img src={Photo} alt="" />
            </div>
        </div>
    )
}

export default AccountManag